module.exports = __webpack_public_path__ + "img/DU_LICH.20c5460a.svg";